import React, {useEffect, useRef, useState} from 'react';
import { Button, Drawer, PageHeader, Table } from 'antd';
import moment from 'moment';
import { getD365HourLogPeriods } from '../../api/d365Api';
import { reverse, sortBy } from 'lodash';
import { HourLogBreakdown } from './HourLogBreakdown';
import {getPaginationConfig} from "../../util/showAllPagination";
import {useDynamicTableHeight} from "../../util/useDynamicTableHeight";

const DATE_FORMAT = 'MM/DD/YYYY';

const HourLogPeriods = () => {
  const [periods, setPeriods] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showBreakdown, setShowBreakdown] = useState(false);
  const [selectedPeriod, setSelectedPeriod] = useState({});
  const tableContainerRef = useRef(null);
  const tableHeight = useDynamicTableHeight(tableContainerRef);

  const columns = [
    {
      title: 'Start Date',
      defaultSortOrder: 'descend',
      sorter: (a, b) => moment(a.startDate).isAfter(moment(b.startDate)),
      render: r => moment(r.startDate).utc().format(DATE_FORMAT)
    },
    {
      title: 'End Date',
      sorter: (a, b) => moment(a.endDate).isAfter(moment(b.endDate)),
      render: r => moment(r.endDate).utc().format(DATE_FORMAT)
    },
    {
      dataIndex: 'projectorTotalHours',
      title: 'Projector Total Hours'
    },
    {
      dataIndex: 'hourLogTotalHours',
      title: 'Hour Log Total Hours'
    },
    {
      dataIndex: 'projectorTotalCount',
      title: 'Projector Total Count'
    },
    {
      dataIndex: 'hourLogTotalCount',
      title: 'Hour Log Count'
    },
    {
      title: 'Actions',
      render: r => (
        <Button onClick={() => loadBreakdown(r)}>View Breakdown</Button>
      )
    }
  ];

  const loadBreakdown = (record) => {
    setSelectedPeriod(record);
    setShowBreakdown(true);
  };

  const hideBreakdown = () => {
    setShowBreakdown(false);
  };

  const formatDate = p => {
    return `${moment(p.startDate).utc().format(DATE_FORMAT)} - ${moment(p.endDate).utc().format(DATE_FORMAT)}`;
  }

  const load = async () => {
    try {
      setLoading(true);
      const periods = await getD365HourLogPeriods();
      const sorted = reverse(sortBy(periods, r => moment(r.StartDate).unix()));
      setPeriods(sorted);
    } catch (e) {
      console.error('Could not get log periods');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <PageHeader title="Hour Log Periods" style={{padding: 0}}/>

      <Table
        ref={tableContainerRef}
        rowKey="ID"
        dataSource={periods}
        columns={columns}
        pagination={getPaginationConfig(periods.length)}
        size="small"
        loading={loading}
        scroll={{y:tableHeight}}
      />

      <Drawer
        title={`Hour Log Breakdown - ${selectedPeriod ? formatDate(selectedPeriod) : '-'}`}
        placement="bottom"
        closable={false}
        onClose={hideBreakdown}
        open={showBreakdown}
      >
        {showBreakdown && (
          <HourLogBreakdown period={selectedPeriod}/>
        )}
      </Drawer>
    </>
  )
    ;
};

export { HourLogPeriods };